import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import {
    ConfirmPasswordResetForm,
    useConfirmPasswordReset,
} from '@/features/users/confirm-password-reset';
import { RequestPasswordReset } from '@/features/users/request-password-reset';
import { AuthCard } from '@/shared/ui/auth/auth-card';

type Props = {
    token: string;
};

export function ResetPasswordPage({ token }: Props) {
    const {
        tokenState,
        password,
        errors,
        isSubmitting,
        setPassword,
        handlePasswordBlur,
        handleSubmit,
    } = useConfirmPasswordReset(token);

    if (tokenState === 'checking') {
        return <LoadingPage />;
    }

    return (
        <div className="flex flex-1 items-start justify-center px-4">
            <AuthCard size="narrow" className="mt-28">
                {tokenState === 'invalid' ? (
                    <RequestPasswordReset expired />
                ) : (
                    <div className="flex flex-col gap-4">
                        <h1 className="text-3xl font-bold md:text-4xl">Set a new password</h1>
                        <ConfirmPasswordResetForm
                            password={password}
                            error={errors.password}
                            formError={errors.form}
                            isSubmitting={isSubmitting}
                            setPassword={setPassword}
                            onPasswordBlur={handlePasswordBlur}
                            onSubmit={handleSubmit}
                        />
                    </div>
                )}
            </AuthCard>
        </div>
    );
}
